import { useTranslation } from "react-i18next";

import { ConfirmActionButton } from "./ConfirmActionButton";

// TODO: Use this instead of buttons in other pages
interface DeleteButtonProps {
  /** Async delete handler; should return true on success */
  handleDelete: () => Promise<boolean>;
  /** Optional button label, defaults to "Delete" */
  buttonLabel?: string;
  /** Confirmation message, defaults to generic */
  confirmMessage?: string;
  /** If false, skips confirmation modal and deletes immediately */
  requireConfirmation?: boolean;
  disabled?: boolean
}

export const DeleteButton: React.FC<DeleteButtonProps> = ({
  handleDelete,
  buttonLabel,
  confirmMessage,
  requireConfirmation = true,
  disabled = false
}) => {
  const { t } = useTranslation();

  return (
    <ConfirmActionButton
      onAction={handleDelete}
      variant="danger"
      actionLabel={t("actions.delete")}
      mnemonic="d"
      confirmTitle={t("actions.confirmDeletion")}
      confirmMessage={confirmMessage ?? t("actions.confirmDeleteMessage")}
      buttonLabel={buttonLabel ?? t("actions.delete")}
      requireConfirmation={requireConfirmation}
      disabled={disabled}
    />
  );
};

export default DeleteButton;
